module.exports = __webpack_public_path__ + "static/media/logobook.c9177c62.png";